import React from "react";

export const ToolFnContext = React.createContext<any>({
  marked: () => {},
  textFiltering: () => {},
  filterText: () => {},
  distinguishSwitch: false,
  regUrl: undefined,
  textTags: undefined,
  selectPersonFn: undefined,
  previewImg: undefined,
  btnExtraHandle: undefined,
  track: undefined,
  contentJumpHandle: undefined,
  parentBoxName: undefined,
  msgId: undefined,
  openUserInfoCard: undefined,
});
